import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "indigo-bookable-faded",
  "use": "indigo-bookable-faded-usage",
  "viewBox": "0 0 23 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 24\" id=\"indigo-bookable-faded\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h23v24H0z\" />\n        <path fill=\"#AA91CB\" d=\"M11.588 0C5.558 0 1 4.626 1 10.506c0 5.344 3.756 8.636 10.211 13.368a.659.659 0 0 0 .76.01c5.885-4.093 10.205-8.016 10.205-13.378C22.176 4.586 17.618 0 11.588 0\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol